import { ICellRendererParams } from 'ag-grid-community';
import { useStyles } from 'components/shared/data/DataGrid/renderers/cell/IndentCell/IndentCell.styles';
import React, { FC } from 'react';

export const IndentCell: FC<ICellRendererParams> = (props) => {
  const classes = useStyles({ indent: props.data.level });

  return <span className={classes.indent}>{props.value}</span>;
};
